export * from "./pickup-icon.component";
